class ListingsController {
    init() {

    }

    index() {
        // Table functionality now handled by modern Stimulus table controller
    }

    new() {
        listingsOnEditOrNew();
    }

    edit() {
        listingsOnEditOrNew();
    }

    for_rent() {
        let contentSwiper = new window.Swiper(".swiper-container.swiper-content", {
            centeredSlides: true,
            keyboard: true,
            autoHeight: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
        let thumbSwiper = new window.Swiper(".swiper-container.swiper-nav", {
            direction: "horizontal",
            slidesPerView: 'auto',
            centeredSlides: true,
            touchRatio: 0.2,
            slideToClickedSlide: true,
            spaceBetween: 10
        });
        contentSwiper.params.control = thumbSwiper;
        thumbSwiper.params.control = contentSwiper;
    }
}

window.BC = window.BC || {};
window.BC.listings = new ListingsController();

function listingsOnEditOrNew() {
    blurToCurrency(0, [
        '#listing_price',
        '#listing_commcredit'
    ]);
    
    // Handle listing submit
    const listingSubmit = document.getElementById("listing_submit");
    if (listingSubmit) {
        listingSubmit.addEventListener("click", function() {
            const priceField = document.getElementById("listing_price");
            const editListing = document.querySelector(".edit_listing");
            
            if (priceField) {
                // Remove any formatting from the price field (replace non-numeric chars)
                const cleanValue = priceField.value.replace(/[^0-9.-]/g, '');
                priceField.value = cleanValue;
            }
            
            if (editListing) {
                editListing.submit();
            }
        });
    }
    
    // Character limit functionality now handled by Stimulus character_limit_controller
    // Applied via data-controller="character-limit" in the HTML forms
    
    // Handle dynamic fields (remove_fields)
    document.addEventListener("click", function(event) {
        if (event.target.matches(".remove_fields")) {
            const hiddenInput = event.target.previousElementSibling;
            if (hiddenInput && hiddenInput.type === "hidden") {
                hiddenInput.value = "1";
            }
            const fieldsContainer = event.target.closest(".fields");
            if (fieldsContainer) {
                fieldsContainer.style.display = "none";
            }
            event.preventDefault();
        }
    });
    
    // Handle dynamic fields (add_fields)
    document.addEventListener("click", function(event) {
        if (event.target.matches(".add_fields")) {
            const time = new Date().getTime();
            const dataId = event.target.dataset.id;
            const dataFields = event.target.dataset.fields;
            
            if (dataId && dataFields) {
                const regexp = new RegExp(dataId, "g");
                const newFields = dataFields.replace(regexp, time);
                event.target.insertAdjacentHTML('beforebegin', newFields);
            }
            event.preventDefault();
        }
    });
}